import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=2b43af08&"
import script from "./heart.vue?vue&type=script&lang=ts&"
export * from "./heart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports